import { format, parseISO } from "date-fns"
import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'bookmarked',
    className: 'toggle-bookmark',
    width: '40px',
    orderable: false,
    render: (data, type, row) => {
      const isStarred = data === 'true'
      return renderToString(
        <button data-id={row.id} className={`toggle-bookmark button naked ${isStarred ? 'is-starred' : ''}`}>
          <span className='star-default'>
            <SvgIconsBookmarkStar solid={isStarred} />
          </span>
          <span className='star-hover'>
            {isStarred ? (
              <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M6 6l12 12M18 6L6 18' />
              </svg>
            ) : (
              <SvgIconsBookmarkStar solid />
            )}
          </span>
        </button>
      )
    },
  },
  {
    data: 'name',
    width: '35%',
    className: 'bold',
    render: (data, type, row, meta) => {
      const date = row['created_at'] ? format(parseISO(row['created_at'].replace(' ', 'T').replace(' UTC', 'Z')), "do MMMM yyyy, HH:mm") : ''
      const isDiscarded = row['discarded'] === 'true'
      const name = isDiscarded ? data : <a href={`/admin/flows/${row.DT_RowId}/overview`}>{data}</a>
      const tags = _.compact(decodeURIComponent(row['tags'] || '').split('||'))

      return renderToString(
        <div>
          {name}<br />
          <span className='small-text'>Created: {date}</span>
          {tags.length > 0 && <><br />
            {tags.map(tag => <span className='tag' key={tag}>{tag}</span>)}
          </>}
          {isDiscarded && <><br />
            <button className="button secondary small margin-top half restore-flow" data-flow-id={row.DT_RowId}>Restore page</button>
          </>}
        </div>
      )
    }
  },
  {
    data: 'wizard_name',
    width: '25%',
  },
  {
    data: 'status',
    width: '15%',
    render: function (data, type, row, meta) {
      function getClass() {
        const status = row['status']
        if (status === 'live') return 'accent'
        if (status === 'closed') return 'blue-100'

        return 'purple-60'
      }

      var status = row['status']

      return `<span class="bold ${getClass()} capitalize">${status}</span>`
    },
  },
  {
    data: 'stats',
    width: '30%',
    render: function (data, type, row, meta) {
      if (row['status'] === 'draft') {
        return '';
      } else {
        const statsData = typeof data === 'string' ? JSON.parse(data) : data;
        let output = '';
        statsData.forEach(([label, count]) => {
          if (label !== 'Redirect') {
            output += `<div class='horizontal-stat'><strong class="purple-80">${label}</strong><span>${count}</span></div>`;
          }
        });

        return output;
      }
    }
  },
  { data: 'created_at', visible: false },
  { data: 'slug', visible: false }
]

const headers = ['', 'Name', 'Template', 'Status', 'Completions', 'Created', 'Slug']

const organisationKinds = window.ENV.ORGANISATION_KINDS.map(kind => ({
  label: kind.label,
  value: kind.external_type
}))

const filters = [
  {
    name: 'Status', column: 3, kind: 'radio', options: [
      { value: 'draft', label: 'Draft' },
      { value: 'live', label: 'Live' },
      { value: 'paused', label: 'Paused' },
      { value: 'closed', label: 'Closed' }
    ]
  },
  { name: 'Using a template', kind: 'async', entity: 'flow_template' },
  { name: 'Tag', kind: 'async', entity: 'tag' },
  { name: 'Created by', kind: 'async', entity: 'user' },
  { name: 'Organisation', kind: 'async', entity: 'organisation' },
]

if (organisationKinds.length > 1) {
  filters.push({
    name: 'Organisation type', kind: 'radio-async', entity: 'external_type', options: organisationKinds
  })
}

const sorters = [
  { column: 5, label: 'Created', order: 'desc' },
  { column: 1, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 1, label: 'Alphabetically (Z-A)', order: 'desc' }
]

const order = [[5, "desc"]]

const defaultFilters = [{
  name: "Organisation",
  label: window.ENV.ORGANISATION_NAME,
  value: window.ENV.ORGANISATION_ID
}]

export { columns, headers, filters, defaultFilters, sorters, order }
